import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";
import { MessageSquare } from "lucide-react";

export default function Messages() {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/messages/threads");
        setThreads(res.data);
      } finally { setLoading(false); }
    })();
  }, []);

  const openThread = (t) => {
    if (t.issue_id) {
      // Pass the peer's user_id so IssueDetail auto-opens the chat panel.
      navigate(`/issue/${t.issue_id}?chat=${encodeURIComponent(t.other_id || "")}`);
    } else if (t.other_id) {
      // Edge case: thread without an attached issue — open the direct chat URL.
      navigate(`/messages/${t.thread_id}`);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B]">
      <Navbar />
      <main className="max-w-[1000px] mx-auto px-4 sm:px-8 lg:px-12 py-10">
        <div className="label-eyebrow mb-3">PRIVATE CHANNELS</div>
        <h1 className="font-heading text-4xl font-black tracking-tighter mb-8">Messages</h1>

        {loading ? (
          <div className="text-zinc-500">Loading...</div>
        ) : threads.length === 0 ? (
          <div className="border border-dashed border-white/10 p-12 text-center text-zinc-500">
            <MessageSquare className="w-10 h-10 mx-auto mb-4 text-zinc-700" strokeWidth={1.2} />
            No conversations yet.
          </div>
        ) : (
          <div className="border border-white/10 divide-y divide-white/10">
            {threads.map((t) => (
              <button
                key={t.thread_id}
                onClick={() => openThread(t)}
                className="w-full bg-[#121214] hover:bg-white/5 p-5 text-left flex items-center gap-4 transition-colors"
                data-testid={`thread-${t.thread_id}`}
              >
                <div className="w-10 h-10 bg-zinc-800 flex items-center justify-center">
                  <MessageSquare className="w-5 h-5 text-zinc-500" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading font-bold text-sm mb-1">{t.other_name}</div>
                  <div className="text-xs text-zinc-500 truncate">{t.last_message?.text}</div>
                </div>
                <div className="text-[10px] text-zinc-600 font-mono">
                  {new Date(t.last_message?.created_at).toLocaleDateString()}
                </div>
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
